import { defineComponent as p, useSlots as b, openBlock as a, createBlock as i, unref as e, mergeProps as s, withCtx as r, createSlots as g, renderSlot as m, createCommentVNode as u, createElementVNode as v, createVNode as h, createElementBlock as k } from "vue";
import B from "./ghl-ui.es380.js";
import { downloadFromDOM as D } from "./ghl-ui.es69.js";
import "./ghl-ui.es23.js";
import "./ghl-ui.es381.js";
import U from "./ghl-ui.es174.js";
import $ from "./ghl-ui.es382.js";
import C from "./ghl-ui.es72.js";
import I from "./ghl-ui.es237.js";
import N from "./ghl-ui.es383.js";
const S = { class: "hl-upload-icon" }, x = { key: 0 }, L = p({
  name: "UIUpload"
}), P = p({
  ...L,
  props: {
    multiple: {
      type: Boolean,
      default: !1
    },
    fileList: {
      type: Array,
      default: () => []
    },
    max: Number,
    type: {
      type: String,
      default: "draggable"
    },
    buttonProps: Object,
    showDownloadButton: Boolean,
    accept: String,
    onDownload: Function
  },
  emits: ["change", "remove", "update:file-list", "download"],
  setup(o, { emit: f }) {
    const c = o, w = f, d = b(), y = (t) => t ? c.onDownload ? (w("download", t), !1) : (D(t), !1) : null;
    return (t, n) => (a(), i(e($), s({ "list-type": "image" }, t.$attrs, {
      accept: o.accept,
      "file-list": o.fileList,
      max: o.max,
      multiple: o.multiple,
      "show-download-button": o.showDownloadButton,
      onChange: n[0] || (n[0] = (l) => t.$emit("change", l)),
      onDownload: y,
      onRemove: n[1] || (n[1] = (l) => t.$emit("remove", l)),
      "onUpdate:fileList": n[2] || (n[2] = (l) => t.$emit("update:file-list", l))
    }), {
      default: r(() => [
        o.type == "button" ? (a(), i(e(C), s({
          key: 0,
          id: `hl-upload__button-type__${e(I)()}`
        }, o.buttonProps), g({
          default: r(() => [
            e(d).buttonContent ? m(t.$slots, "buttonContent", { key: 0 }, void 0, !0) : u("", !0)
          ]),
          _: 2
        }, [
          e(d).buttonIcon ? {
            name: "icon",
            fn: r(() => [
              m(t.$slots, "buttonIcon", {}, void 0, !0)
            ]),
            key: "0"
          } : void 0
        ]), 1040, ["id"])) : (a(), i(e(N), { key: 1 }, {
          default: r(() => [
            v("div", S, [
              h(e(B), { class: "text-gray-600" })
            ]),
            e(d).extra ? (a(), k("div", x, [
              m(t.$slots, "extra", {}, void 0, !0)
            ])) : u("", !0)
          ]),
          _: 3
        }))
      ]),
      _: 3
    }, 16, ["accept", "file-list", "max", "multiple", "show-download-button"]));
  }
}), G = /* @__PURE__ */ U(P, [["__scopeId", "data-v-7d92c056"]]);
export {
  G as default
};
